export const MLB = "/mlb";
export const MLB_SCORES_MATCHES_DAY_GAMEID = "/mlb/scores/matches/:day/:gameId";
export const MLB_TEAMS_SLUG = "/mlb/teams/:slug";
export const BLOG_SPORT = "/blog/:sport";
export const BLOG = "/blog";
export const FOOTBALL_CLUBS_SLUG = "/football/clubs/:slug";
export const FOOTBALL_COUNTRIES_COUNTRYCODE = "/football/countries/:countryCode";
export const FOOTBALL = "/football";
export const FOOTBALL_LEAGUES_SLUG = "/football/leagues/:slug";
export const FOOTBALL_ONBOARDING = "/football/onboarding";
export const FOOTBALL_PLAY_EVENTTYPE_ONBOARDING = "/football/play/:eventType/onboarding";
export const FOOTBALL_SCORES_MATCHES_DAY_GAMEID = "/football/scores/matches/:day/:gameId";
export const FOOTBALL_TEAMS_SLUG = "/football/teams/:slug";
export const ANY_SPORT_ESSENCE_TYPE = "/essence/:type";
export const ANY_SPORT_HOME_EVENTTYPE = "/home/:eventType";
export const ANY_SPORT_HOME = "/home";
export const ANY_SPORT_MARKET_SHOP = "/market/shop";
export const ANY_SPORT_MARKET = "/market";
export const ANY_SPORT_MARKET_SCOUT = "/market/scout";
export const ANY_SPORT_MARKET_WATCHLISTS_ID = "/market/watchlists/:id";
export const ANY_SPORT_MARKET_WATCHLISTS_FAVORITES = "/market/watchlists/favorites";
export const ANY_SPORT_MARKET_WATCHLISTS = "/market/watchlists";
export const ANY_SPORT_MISSIONS_CATEGORY_RARITY = "/missions/:category/:rarity";
export const ANY_SPORT_MISSIONS_CATEGORY = "/missions/:category";
export const ANY_SPORT_MISSIONS = "/missions";
export const ANY_SPORT_MY_CARDS_COLLECTION_COLLECTIONSLUG = "/my-cards/collection/:collectionSlug";
export const ANY_SPORT_MY_CARDS_CARDS = "/my-cards/cards";
export const ANY_SPORT_MY_CARDS_COLLECTIONS = "/my-cards/collections";
export const ANY_SPORT_MY_CARDS_GALLERY_RARITY = "/my-cards/gallery/:rarity";
export const ANY_SPORT_MY_CARDS = "/my-cards";
export const ANY_SPORT_MY_CARDS_REVEALABLE_CARDS = "/my-cards/revealable-cards";
export const ANY_SPORT_MY_CARDS_VAULT = "/my-cards/vault";
export const ANY_SPORT_MY_CIRCLES_EVENTTYPE_FIXTURE = "/my-circles/:eventType/:fixture";
export const ANY_SPORT_MY_CLUB_SLUG_CARDS = "/my-club/:slug/cards";
export const ANY_SPORT_MY_CLUB_SLUG_COLLECTIONS_COLLECTION = "/my-club/:slug/collections/:collection";
export const ANY_SPORT_MY_CLUB_SLUG = "/my-club/:slug";
export const ANY_SPORT_MY_CLUB_SLUG_TRANSACTIONS = "/my-club/:slug/transactions";
export const ANY_SPORT_MY_CLUB_SLUG_VAULT = "/my-club/:slug/vault";
export const ANY_SPORT_NO_CARD_ROUTE = "/no-card-route";
export const ANY_SPORT_ONBOARDING = "/onboarding";
export const ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_COMPETITION_COMPETITION_TRCKGRP_TRCK_REWARDS = "/play/:eventType/:fixture/competition/:competition/:trckGrp/:trck/rewards";
export const ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_COMPETITION_COMPETITION_TRCKGRP_TRCK = "/play/:eventType/:fixture/competition/:competition/:trckGrp/:trck";
export const ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_COMPETITION_COMPETITION_TRCKGRP = "/play/:eventType/:fixture/competition/:competition/:trckGrp";
export const ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_REWARDS = "/play/:eventType/:fixture/rewards";
export const ANY_SPORT_PLAY_EVENTTYPE_FIXTURE = "/play/:eventType/:fixture";
export const ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_LINEUPS = "/play/:eventType/:fixture/lineups";
export const ANY_SPORT_PLAY_EVENTTYPE_ARENA_FIXTURE_COMPETITION_COMPETITION_TRCKGRP_TRCK_REWARDS = "/play/:eventType/arena/:fixture/competition/:competition/:trckGrp/:trck/rewards";
export const ANY_SPORT_PLAY_EVENTTYPE_ARENA_FIXTURE_COMPETITION_COMPETITION_TRCKGRP_TRCK = "/play/:eventType/arena/:fixture/competition/:competition/:trckGrp/:trck";
export const ANY_SPORT_PLAY_EVENTTYPE_ARENA_FIXTURE_COMPETITION_COMPETITION_TRCKGRP = "/play/:eventType/arena/:fixture/competition/:competition/:trckGrp";
export const ANY_SPORT_PLAY_EVENTTYPE_ARENA_FIXTURE = "/play/:eventType/arena/:fixture";
export const ANY_SPORT_PLAY_EVENTTYPE_CHAMPIONSHIP_USERGROUP = "/play/:eventType/championship/:userGroup";
export const ANY_SPORT_PLAY_EVENTTYPE_CHAMPIONSHIP = "/play/:eventType/championship";
export const ANY_SPORT_PLAY_EVENTTYPE = "/play/:eventType";
export const ANY_SPORT_PLAY = "/play";
export const ANY_SPORT_PLAY_QUICK_PLAY_TRCK = "/play/quick-play/:trck";
export const ANY_SPORT_PLAY_QUICK_PLAY = "/play/quick-play";
export const ANY_SPORT_PLAYERS_SLUG_CARDS = "/players/:slug/cards";
export const ANY_SPORT_PLAYERS_SLUG = "/players/:slug";
export const ANY_SPORT_REWARDS_FIXTURE = "/rewards/:fixture";
export const ANY_SPORT_REWARDS_ESSENCE = "/rewards/essence";
export const ANY_SPORT_SCORES = "/scores";
export const ANY_SPORT_SCORES_MATCHES_DAY = "/scores/matches/:day";
export const ANY_SPORT_SCORES_TOP_PLAYERS_EVENTTYPE_FIXTURE = "/scores/top-players/:eventType/:fixture";
export const ANY_SPORT_SERIES = "/series";
export const ANY_SPORT_SERIES_MARKET = "/series/market";
export const ANY_SPORT_SERIES_PLAY = "/series/play";
export const HELP = "/help";
export const NBA = "/nba";
export const NBA_ONBOARDING = "/nba/onboarding";
export const NBA_PLAY_CHASE_USERGROUP = "/nba/play/chase/:userGroup";
export const NBA_SCORES_MATCHES_DAY_GAMEID = "/nba/scores/matches/:day/:gameId";
export const NBA_TEAMS_SLUG = "/nba/teams/:slug";
export const ACTIVITY = "/activity";
export const CONTENT_CREATORS = "/content-creators";
export const INVITE = "/invite";
export const LICENSED_PARTNERS = "/licensed-partners";
export const MY_SORARE = "/my-sorare";
export const MY_SORARE_OFFERS = "/my-sorare/offers";
export const MY_SORARE_PURCHASES = "/my-sorare/purchases";
export const MY_SORARE_TRANSACTIONS = "/my-sorare/transactions";
export const PROMO_CLAIM_CODE = "/promo/claim/:code";
export const SETTINGS = "/settings";
export const MLB_COMPOSE_TEAM_LEADERBOARDSLUG_LINEUPID = "/mlb/compose-team/:leaderboardSlug/:lineupId";
export const MLB_COMPOSE_TEAM_LEADERBOARDSLUG = "/mlb/compose-team/:leaderboardSlug";
export const MLB_HOWTOPLAY = "/mlb/howToPlay";
export const MLB_ONBOARDING = "/mlb/onboarding";
export const MLB_PLAY_EVENTTYPE_FIXTURE_GAME_CENTER = "/mlb/play/:eventType/:fixture/game-center";
export const MLB_PLAY_EVENTTYPE_COMPOSE_LEADERBOARD_LINEUP_LINEUP = "/mlb/play/:eventType/compose/:leaderboard/lineup/:lineup";
export const MLB_PLAY_EVENTTYPE_COMPOSE_LEADERBOARD_MANAGERTEAM_MANAGERTEAM = "/mlb/play/:eventType/compose/:leaderboard/managerTeam/:managerTeam";
export const MLB_PLAY_EVENTTYPE_COMPOSE_LEADERBOARD = "/mlb/play/:eventType/compose/:leaderboard";
export const MLB_PLAY_EVENTTYPE_LINEUPS_ID = "/mlb/play/:eventType/lineups/:id";
export const MLB_SCORES_MATCHES_DAY_GAMEID_BOX_SCORE = "/mlb/scores/matches/:day/:gameId/box-score";
export const MLB_SCORES_MATCHES_DAY_GAMEID_PLAYERS = "/mlb/scores/matches/:day/:gameId/players";
export const MLB_SCOUTING_CENTER_GAME_GAMEID = "/mlb/scouting-center/game/:gameId";
export const MLB_TEAMS_SLUG_CARDS = "/mlb/teams/:slug/cards";
export const MLB_TEAMS_SLUG_PLAYERS = "/mlb/teams/:slug/players";
export const BLOG_SPORT_SLUG = "/blog/:sport/:slug";
export const BLOG_SPORT_CATEGORY_CATEGORY = "/blog/:sport/category/:category";
export const P_SLUG = "/p/:slug";
export const FOOTBALL_BUNDESLIGA = "/football/bundesliga";
export const FOOTBALL_BUNDLED_AUCTIONS_ID = "/football/bundled-auctions/:id";
export const FOOTBALL_CLUBS_SLUG_CARDS = "/football/clubs/:slug/cards";
export const FOOTBALL_CLUBS_SLUG_FIXTURES = "/football/clubs/:slug/fixtures";
export const FOOTBALL_CLUBS_SLUG_STANDINGS = "/football/clubs/:slug/standings";
export const FOOTBALL_CLUBS_SLUG_TEAM = "/football/clubs/:slug/team";
export const FOOTBALL_COUNTRIES_COUNTRYCODE_CARDS = "/football/countries/:countryCode/cards";
export const FOOTBALL_COUNTRIES_COUNTRYCODE_FIXTURES = "/football/countries/:countryCode/fixtures";
export const FOOTBALL_COUNTRIES_COUNTRYCODE_TEAM = "/football/countries/:countryCode/team";
export const FOOTBALL_EPL = "/football/epl";
export const FOOTBALL_LALIGA_SANTANDER = "/football/laliga-santander";
export const FOOTBALL_LALIGA = "/football/laliga";
export const FOOTBALL_LEAGUES_SLUG_CARDS = "/football/leagues/:slug/cards";
export const FOOTBALL_LEAGUES_SLUG_FIXTURES = "/football/leagues/:slug/fixtures";
export const FOOTBALL_LIGUE_1 = "/football/ligue-1";
export const FOOTBALL_LOAN = "/football/loan";
export const FOOTBALL_MARKET_SHOP_AUCTIONS = "/football/market/shop/auctions";
export const FOOTBALL_MARKET_SHOP_MANAGER_SALES = "/football/market/shop/manager-sales";
export const FOOTBALL_MARKET_MOBILE_COMMON_PACKS = "/football/market/mobile-common-packs";
export const FOOTBALL_MARKET_MOBILE_INSTANT_BUY = "/football/market/mobile-instant-buy";
export const FOOTBALL_MARKET_MOBILE_NEW_SIGNINGS = "/football/market/mobile-new-signings";
export const FOOTBALL_MARKET_SCOUT_LEADERBOARDGROUP = "/football/market/scout/:leaderboardGroup";
export const FOOTBALL_MARKET_SCOUT = "/football/market/scout";
export const FOOTBALL_MARKET_SCOUT_SO5_COMPETITION_SLUG = "/football/market/scout/so5-competition/:slug";
export const FOOTBALL_ONBOARDING_COMPOSE_SLUG = "/football/onboarding/compose/:slug";
export const FOOTBALL_ONBOARDING_QUICK_PLAY_TUTORIAL = "/football/onboarding/quick-play-tutorial";
export const FOOTBALL_PL = "/football/pl";
export const FOOTBALL_PLAY_EVENTTYPE_FIXTURE_MATCH_CENTER = "/football/play/:eventType/:fixture/match-center";
export const FOOTBALL_PLAY_EVENTTYPE_COMPOSE_LEADERBOARD_LINEUP_LINEUP = "/football/play/:eventType/compose/:leaderboard/lineup/:lineup";
export const FOOTBALL_PLAY_EVENTTYPE_COMPOSE_LEADERBOARD_MANAGERTEAM_MANAGERTEAM = "/football/play/:eventType/compose/:leaderboard/managerTeam/:managerTeam";
export const FOOTBALL_PLAY_EVENTTYPE_COMPOSE_LEADERBOARD = "/football/play/:eventType/compose/:leaderboard";
export const FOOTBALL_PLAY_EVENTTYPE_LINEUPS_ID = "/football/play/:eventType/lineups/:id";
export const FOOTBALL_PLAY_EVENTTYPE_MY_LINEUPS_ID = "/football/play/:eventType/my-lineups/:id";
export const FOOTBALL_PLAY_REWARDS = "/football/play/rewards";
export const FOOTBALL_PREMIER_LEAGUE = "/football/premier-league";
export const FOOTBALL_SCORES_MATCHES_DAY_GAMEID_LINEUPS = "/football/scores/matches/:day/:gameId/lineups";
export const FOOTBALL_SCORES_MATCHES_DAY_GAMEID_PLAYERS = "/football/scores/matches/:day/:gameId/players";
export const FOOTBALL_SCORES_MATCHES_DAY_GAMEID_STATS = "/football/scores/matches/:day/:gameId/stats";
export const FOOTBALL_SCOUTING_CENTER_GAME_GAMEID = "/football/scouting-center/game/:gameId";
export const FOOTBALL_SCOUTING_CENTER_STATS_LEADERBOARDGROUP = "/football/scouting-center/stats/:leaderboardGroup";
export const FOOTBALL_SCOUTING_CENTER_STATS_SO5_COMPETITION_SLUG = "/football/scouting-center/stats/so5-competition/:slug";
export const FOOTBALL_TEAMS_SLUG_CARDS = "/football/teams/:slug/cards";
export const FOOTBALL_TEAMS_SLUG_FIXTURES = "/football/teams/:slug/fixtures";
export const FOOTBALL_TEAMS_SLUG_STANDINGS = "/football/teams/:slug/standings";
export const FOOTBALL_TEAMS_SLUG_TEAM = "/football/teams/:slug/team";
export const ANY_SPORT_BLOG_SLUG = "/blog/:slug";
export const ANY_SPORT_BUY_GEMS = "/buy-gems";
export const ANY_SPORT_CARDS_SLUG = "/cards/:slug";
export const ANY_SPORT_ENABLE_NOTIFICATIONS = "/enable-notifications";
export const ANY_SPORT_ESSENCE = "/essence";
export const ANY_SPORT_GALLERY_SLUG = "/gallery/:slug";
export const ANY_SPORT_HOW_TO_PLAY = "/how-to-play";
export const ANY_SPORT_INVITE = "/invite";
export const ANY_SPORT_MARKET_LEGACY_PACKS = "/market/legacy-packs";
export const ANY_SPORT_MARKET_SHOP_AUCTIONS = "/market/shop/auctions";
export const ANY_SPORT_MARKET_SHOP_INSTANT_BUY = "/market/shop/instant-buy";
export const ANY_SPORT_MARKET_SHOP_MANAGER_SALES_PLAYERSLUG_RARITY = "/market/shop/manager-sales/:playerSlug/:rarity";
export const ANY_SPORT_MARKET_SHOP_MANAGER_SALES = "/market/shop/manager-sales";
export const ANY_SPORT_MARKET_AUCTIONS = "/market/auctions";
export const ANY_SPORT_MARKET_COMMON_PACKS_GROUP = "/market/common-packs/:group";
export const ANY_SPORT_MARKET_COMMON_PACKS = "/market/common-packs";
export const ANY_SPORT_MARKET_HOME = "/market/home";
export const ANY_SPORT_MARKET_INSTANT_BUY = "/market/instant-buy";
export const ANY_SPORT_MARKET_MANAGER_SALES = "/market/manager-sales";
export const ANY_SPORT_MARKET_NEW_SIGNINGS = "/market/new-signings";
export const ANY_SPORT_MARKET_PRIMARY = "/market/primary";
export const ANY_SPORT_MARKET_WHEEL_RARITY = "/market/wheel/:rarity";
export const ANY_SPORT_MARKET_WHEEL = "/market/wheel";
export const ANY_SPORT_MY_CARDS_COLLECTION_COLLECTIONSLUG_CARDS = "/my-cards/collection/:collectionSlug/cards";
export const ANY_SPORT_MY_CARDS_COLLECTION_COLLECTIONSLUG_LEADERBOARD = "/my-cards/collection/:collectionSlug/leaderboard";
export const ANY_SPORT_MY_CARDS_HALL_OF_FAME_RARITY_SEASONSTARTYEAR = "/my-cards/hall-of-fame/:rarity/:seasonStartYear";
export const ANY_SPORT_MY_CARDS_CARDS_TYPE_SET = "/my-cards/cards/:type/:set";
export const ANY_SPORT_MY_CARDS_CARDS_TYPE = "/my-cards/cards/:type";
export const ANY_SPORT_MY_CARDS_COLLECTIONS_TYPE = "/my-cards/collections/:type";
export const ANY_SPORT_MY_CARDS_GALLERY_RARITY_SET_LEAGUE = "/my-cards/gallery/:rarity/:set/:league";
export const ANY_SPORT_MY_CARDS_GALLERY_RARITY_SET = "/my-cards/gallery/:rarity/:set";
export const ANY_SPORT_MY_CARDS_GALLERY = "/my-cards/gallery";
export const ANY_SPORT_MY_CARDS_REVEALABLE_CARDS_TYPE = "/my-cards/revealable-cards/:type";
export const ANY_SPORT_MY_CARDS_VAULT_TYPE = "/my-cards/vault/:type";
export const ANY_SPORT_MY_CIRCLES_EVENTTYPE_FIXTURE_SLUG = "/my-circles/:eventType/:fixture/:slug";
export const ANY_SPORT_MY_CIRCLES_EVENTTYPE = "/my-circles/:eventType";
export const ANY_SPORT_MY_CIRCLES = "/my-circles";
export const ANY_SPORT_MY_CLUB_SLUG_CARDS_TYPE = "/my-club/:slug/cards/:type";
export const ANY_SPORT_MY_CLUB_SLUG_COLLECTIONS_COLLECTION_CARDS = "/my-club/:slug/collections/:collection/cards";
export const ANY_SPORT_MY_CLUB_SLUG_COLLECTIONS_COLLECTION_LEADERBOARD = "/my-club/:slug/collections/:collection/leaderboard";
export const ANY_SPORT_MY_CLUB_SLUG_COLLECTIONS = "/my-club/:slug/collections";
export const ANY_SPORT_MY_CLUB_SLUG_EDIT = "/my-club/:slug/edit";
export const ANY_SPORT_MY_CLUB_SLUG_VAULT_TYPE = "/my-club/:slug/vault/:type";
export const ANY_SPORT_MY_CLUB_SLUG_WATCHLISTS = "/my-club/:slug/watchlists";
export const ANY_SPORT_MY_CLUB = "/my-club";
export const ANY_SPORT_NO_CARD_ROUTE_SO5FIXTUREID_SO5LINEUPID_ACCEPT = "/no-card-route/:so5FixtureId/:so5LineupId/accept";
export const ANY_SPORT_NO_CARD_ROUTE_SO5FIXTUREID_SO5LINEUPID_CANCEL = "/no-card-route/:so5FixtureId/:so5LineupId/cancel";
export const ANY_SPORT_NO_CARD_ROUTE_SO5FIXTUREID_SO5LINEUPID_CONFIRM = "/no-card-route/:so5FixtureId/:so5LineupId/confirm";
export const ANY_SPORT_NO_CARD_ROUTE_SO5FIXTUREID = "/no-card-route/:so5FixtureId";
export const ANY_SPORT_ONBOARDING_SERIES = "/onboarding/series";
export const ANY_SPORT_ONBOARDING_SERIES_SELECT_COMPETITION = "/onboarding/series/select-competition";
export const ANY_SPORT_ONBOARDING_SERIES_SELECT_TEAM_SLUG = "/onboarding/series/select-team/:slug";
export const ANY_SPORT_ONBOARDING_SERIES_WELCOME = "/onboarding/series/welcome";
export const ANY_SPORT_ONBOARDING_TUTORIAL_INTRO = "/onboarding/tutorial/intro";
export const ANY_SPORT_ONBOARDING_TUTORIAL = "/onboarding/tutorial";
export const ANY_SPORT_ONBOARDING_TUTORIAL_PLAY = "/onboarding/tutorial/play";
export const ANY_SPORT_ONBOARDING_TUTORIAL_RECRUIT = "/onboarding/tutorial/recruit";
export const ANY_SPORT_ONBOARDING_TUTORIAL_WIN = "/onboarding/tutorial/win";
export const ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_COMPETITION_COMPETITION_TRCKGRP_TRCK_REWARDS_CONTENDER = "/play/:eventType/:fixture/competition/:competition/:trckGrp/:trck/rewards/:contender";
export const ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_COMPETITION_COMPETITION_TRCKGRP_TRCK_GAMES = "/play/:eventType/:fixture/competition/:competition/:trckGrp/:trck/games";
export const ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_COMPETITION_COMPETITION = "/play/:eventType/:fixture/competition/:competition";
export const ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_COMPETITION_COMPETITION_REWARDS = "/play/:eventType/:fixture/competition/:competition/rewards";
export const ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_COMPETITION = "/play/:eventType/:fixture/competition";
export const ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_CONTENDER_CONTENDER = "/play/:eventType/:fixture/contender/:contender";
export const ANY_SPORT_PLAY_EVENTTYPE_ARENA_FIXTURE_COMPETITION_COMPETITION_TRCKGRP_TRCK_REWARDS_CONTENDER = "/play/:eventType/arena/:fixture/competition/:competition/:trckGrp/:trck/rewards/:contender";
export const ANY_SPORT_PLAY_EVENTTYPE_ARENA_FIXTURE_COMPETITION_COMPETITION_TRCKGRP_TRCK_GAMES = "/play/:eventType/arena/:fixture/competition/:competition/:trckGrp/:trck/games";
export const ANY_SPORT_PLAY_EVENTTYPE_ARENA_FIXTURE_COMPETITION_COMPETITION = "/play/:eventType/arena/:fixture/competition/:competition";
export const ANY_SPORT_PLAY_EVENTTYPE_ARENA_FIXTURE_COMPETITION_COMPETITION_REWARDS = "/play/:eventType/arena/:fixture/competition/:competition/rewards";
export const ANY_SPORT_PLAY_EVENTTYPE_ARENA_FIXTURE_COMPETITION = "/play/:eventType/arena/:fixture/competition";
export const ANY_SPORT_PLAY_EVENTTYPE_ARENA_FIXTURE_CONTENDER_CONTENDER = "/play/:eventType/arena/:fixture/contender/:contender";
export const ANY_SPORT_PLAY_EVENTTYPE_ARENA_FIXTURE_LINEUPS = "/play/:eventType/arena/:fixture/lineups";
export const ANY_SPORT_PLAY_EVENTTYPE_ARENA = "/play/:eventType/arena";
export const ANY_SPORT_PLAY_EVENTTYPE_CHAMPIONSHIP_USERGROUP_USER = "/play/:eventType/championship/:userGroup/:user";
export const ANY_SPORT_PLAY_EVENTTYPE_CHAMPIONSHIP_LEADERBOARD_USERGROUP = "/play/:eventType/championship/leaderboard/:userGroup";
export const ANY_SPORT_PLAY_EVENTTYPE_LEADERBOARD_LEADERBOARD = "/play/:eventType/leaderboard/:leaderboard";
export const ANY_SPORT_PLAY_EVENTTYPE_LEADERBOARD_LEADERBOARD_PRIZE_POOL_CONTENDER = "/play/:eventType/leaderboard/:leaderboard/prize-pool/:contender";
export const ANY_SPORT_PLAY_EVENTTYPE_LEADERBOARD_LEADERBOARD_PRIZE_POOL = "/play/:eventType/leaderboard/:leaderboard/prize-pool";
export const ANY_SPORT_PLAY_EVENTTYPE_LEADERBOARD_LEADERBOARD_RANKINGS_CONTENDER = "/play/:eventType/leaderboard/:leaderboard/rankings/:contender";
export const ANY_SPORT_PLAY_EVENTTYPE_LEADERBOARD_LEADERBOARD_RANKINGS = "/play/:eventType/leaderboard/:leaderboard/rankings";
export const ANY_SPORT_PLAY_EVENTTYPE_LEADERBOARD = "/play/:eventType/leaderboard";
export const ANY_SPORT_PLAY_QUICK_PLAY_TRCK_STEP_APPEARANCEINDEX_DAY_COMPOSE_GAME = "/play/quick-play/:trck/:step/:appearanceIndex/:day/compose/:game";
export const ANY_SPORT_PLAY_QUICK_PLAY_TRCK_STEP_APPEARANCEINDEX_DAY = "/play/quick-play/:trck/:step/:appearanceIndex/:day";
export const ANY_SPORT_PLAY_QUICK_PLAY_TRCK_STEP_APPEARANCEINDEX = "/play/quick-play/:trck/:step/:appearanceIndex";
export const ANY_SPORT_PLAY_SERIES = "/play/series";
export const ANY_SPORT_PLAY_SERIES_VOUCHER = "/play/series/voucher";
export const ANY_SPORT_PLAYERS_SLUG_CARDS_SALES_HISTORY = "/players/:slug/cards/sales-history";
export const ANY_SPORT_PLAYERS_SLUG_FIXTURES = "/players/:slug/fixtures";
export const ANY_SPORT_PLAYERS_SLUG_HISTORY = "/players/:slug/history";
export const ANY_SPORT_PLAYERS_SLUG_TRANSACTIONS = "/players/:slug/transactions";
export const ANY_SPORT_PLAYERS_SLUG_WATCHLISTS = "/players/:slug/watchlists";
export const ANY_SPORT_REWARDS_FIXTURE_LEAGUE_QUALITY_RARITY = "/rewards/:fixture/:league/:quality/:rarity";
export const ANY_SPORT_REWARDS_ESSENCE_QUALITY_RARITY = "/rewards/essence/:quality/:rarity";
export const ANY_SPORT_SCORES_MATCHES = "/scores/matches";
export const ANY_SPORT_SCORES_TOP_PLAYERS_EVENTTYPE = "/scores/top-players/:eventType";
export const ANY_SPORT_SCORES_TOP_PLAYERS = "/scores/top-players";
export const ANY_SPORT_SCOUTING_CENTER_MATCHES = "/scouting-center/matches";
export const ANY_SPORT_SCOUTING_CENTER = "/scouting-center";
export const ANY_SPORT_SCOUTING_CENTER_STATS = "/scouting-center/stats";
export const ANY_SPORT_SCOUTING_CENTER_WATCHLISTS_ID = "/scouting-center/watchlists/:id";
export const ANY_SPORT_SCOUTING_CENTER_WATCHLISTS_FAVORITES = "/scouting-center/watchlists/favorites";
export const ANY_SPORT_SCOUTING_CENTER_WATCHLISTS = "/scouting-center/watchlists";
export const ANY_SPORT_SERIES_TASK_COMPOSE_TEAM_LINEUP = "/series/:task/compose-team/:lineup";
export const ANY_SPORT_SERIES_TASK_COMPOSE_TEAM = "/series/:task/compose-team";
export const ANY_SPORT_SERIES_TASK_LINEUPS = "/series/:task/lineups";
export const ANY_SPORT_SERIES_MARKET_LEGACY_PACKS = "/series/market/legacy-packs";
export const ANY_SPORT_SERIES_MARKET_COMMON_PACKS_GROUP = "/series/market/common-packs/:group";
export const ANY_SPORT_SERIES_MARKET_COMMON_PACKS = "/series/market/common-packs";
export const ANY_SPORT_SERIES_MISSIONS_COLLECT = "/series/missions/collect";
export const ANY_SPORT_SERIES_MISSIONS_PLAY = "/series/missions/play";
export const ANY_SPORT_SERIES_ONBOARDING = "/series/onboarding";
export const ANY_SPORT_SERIES_ONBOARDING_SELECT_COMPETITION = "/series/onboarding/select-competition";
export const ANY_SPORT_SERIES_ONBOARDING_SELECT_TEAM_SLUG = "/series/onboarding/select-team/:slug";
export const ANY_SPORT_SERIES_ONBOARDING_WELCOME = "/series/onboarding/welcome";
export const ANY_SPORT_SERIES_SQUAD_CREATE_OR_JOIN = "/series/squad/create-or-join";
export const ANY_SPORT_SERIES_SQUAD_CREATE = "/series/squad/create";
export const ANY_SPORT_SERIES_SQUAD_CREATED_JOINSECRET = "/series/squad/created/:joinSecret";
export const ANY_SPORT_SERIES_SQUAD_JOIN = "/series/squad/join";
export const ANY_SPORT_SERIES_SQUAD_MEMBERS = "/series/squad/members";
export const ANY_SPORT_SERIES_SQUAD = "/series/squad";
export const HELP_A_ARTICLEID_SLUG = "/help/a/:articleId/:slug";
export const HELP_C_CATEGORYID_SLUG = "/help/c/:categoryId/:slug";
export const HELP_S_SECTIONID_SLUG = "/help/s/:sectionId/:slug";
export const NBA_GAMES_GAMEID_EVENTTYPE = "/nba/games/:gameId/:eventType";
export const NBA_GAMES_GAMEID = "/nba/games/:gameId";
export const NBA_GAMES = "/nba/games";
export const NBA_MARKET_MOBILE_INSTANT_BUY = "/nba/market/mobile-instant-buy";
export const NBA_ONBOARDING_COMPOSE_SLUG = "/nba/onboarding/compose/:slug";
export const NBA_ONBOARDING_QUICK_PLAY_TUTORIAL = "/nba/onboarding/quick-play-tutorial";
export const NBA_PLAY_EVENTTYPE_FIXTURE_GAME_CENTER = "/nba/play/:eventType/:fixture/game-center";
export const NBA_PLAY_EVENTTYPE_COMPOSE_LEADERBOARD_LINEUP_LINEUP = "/nba/play/:eventType/compose/:leaderboard/lineup/:lineup";
export const NBA_PLAY_EVENTTYPE_COMPOSE_LEADERBOARD_MANAGERTEAM_MANAGERTEAM = "/nba/play/:eventType/compose/:leaderboard/managerTeam/:managerTeam";
export const NBA_PLAY_EVENTTYPE_COMPOSE_LEADERBOARD = "/nba/play/:eventType/compose/:leaderboard";
export const NBA_PLAY_EVENTTYPE_LINEUPS_ID = "/nba/play/:eventType/lineups/:id";
export const NBA_PLAY_CHASE_USERGROUP_USER = "/nba/play/chase/:userGroup/:user";
export const NBA_PLAY_CHASE_LEADERBOARD_USERGROUP = "/nba/play/chase/leaderboard/:userGroup";
export const NBA_PLAY_CHASE = "/nba/play/chase";
export const NBA_PLAY_PRO_ONBOARDING = "/nba/play/pro/onboarding";
export const NBA_SCORES_MATCHES_DAY_GAMEID_BOX_SCORE = "/nba/scores/matches/:day/:gameId/box-score";
export const NBA_SCORES_MATCHES_DAY_GAMEID_PLAYERS = "/nba/scores/matches/:day/:gameId/players";
export const NBA_SCORES_MATCHES_DAY_GAMEID_STATS = "/nba/scores/matches/:day/:gameId/stats";
export const NBA_SCORES_PLAYOFFS = "/nba/scores/playoffs";
export const NBA_TEAMS_SLUG_CARDS = "/nba/teams/:slug/cards";
export const NBA_TEAMS_SLUG_PLAYERS = "/nba/teams/:slug/players";
export const ACTIVITY_NEWS_ID = "/activity/news/:id";
export const ACTIVITY_NEWS = "/activity/news";
export const ADMIN_LEADERBOARD_LEADERBOARD_REWARDS = "/admin/leaderboard/:leaderboard/rewards";
export const API_TERMS = "/api-terms";
export const CAREERS = "/careers";
export const CONFIRM_DEVICE = "/confirm-device";
export const CONFIRM_EMAIL = "/confirm-email";
export const COOKIE_POLICY = "/cookie-policy";
export const COVERAGE = "/coverage";
export const CREATOR_PROGRAM = "/creator-program";
export const CREDIT_TERMS = "/credit-terms";
export const DEBUG_DEVICE = "/debug-device";
export const DEEPLINK = "/deeplink";
export const FAQ = "/faq";
export const GAME_RULES = "/game-rules";
export const LEGAL_NOTICE = "/legal-notice";
export const LICENSED_PARTNERS_SPORT_TAB = "/licensed-partners/:sport/:tab";
export const LICENSED_PARTNERS_SPORT = "/licensed-partners/:sport";
export const MARKETPLACE_TERMS = "/marketplace-terms";
export const MOBILE_FORGOT_PASSWORD = "/mobile-forgot-password";
export const MOBILE_SIGN_UP = "/mobile-sign-up";
export const MY_SORARE_FOLLOWS = "/my-sorare/follows";
export const MY_SORARE_OFFERS_RECEIVED_ID = "/my-sorare/offers/received/:id";
export const MY_SORARE_OFFERS_RECEIVED = "/my-sorare/offers/received";
export const MY_SORARE_OFFERS_SALES = "/my-sorare/offers/sales";
export const MY_SORARE_OFFERS_SENT_ID = "/my-sorare/offers/sent/:id";
export const MY_SORARE_OFFERS_SENT = "/my-sorare/offers/sent";
export const MY_SORARE_PLAYERS_NOTIFICATIONS = "/my-sorare/players-notifications";
export const MY_SORARE_PURCHASES_AUCTIONS = "/my-sorare/purchases/auctions";
export const MY_SORARE_PURCHASES_INSTANT_BUYS_ID = "/my-sorare/purchases/instant-buys/:id";
export const MY_SORARE_PURCHASES_INSTANT_BUYS = "/my-sorare/purchases/instant-buys";
export const MY_SORARE_PURCHASES_MANAGER_SALES = "/my-sorare/purchases/manager-sales";
export const MY_SORARE_TRANSACTIONS_CASH = "/my-sorare/transactions/cash";
export const MY_SORARE_TRANSACTIONS_CREDITCARD = "/my-sorare/transactions/creditcard";
export const MY_SORARE_TRANSACTIONS_ESSENCE = "/my-sorare/transactions/essence";
export const MY_SORARE_TRANSACTIONS_ETH = "/my-sorare/transactions/eth";
export const MY_SORARE_TRANSACTIONS_SOL = "/my-sorare/transactions/sol";
export const MY_SORARE_TRANSACTIONS_VIP = "/my-sorare/transactions/vip";
export const NETWORK_SLUG = "/network/:slug";
export const NEWSTART = "/newstart";
export const OAUTH_AUTHORIZE = "/oauth/authorize";
export const LANDING = "/";
export const PRESS = "/press";
export const PRIVACY_POLICY = "/privacy-policy";
export const PROMO_SIGNUP_CODE = "/promo/signup/:code";
export const R_USERSLUG = "/r/:userSlug";
export const SETTINGS_ACCOUNT = "/settings/account";
export const SETTINGS_GLOBAL_PREFERENCES = "/settings/global-preferences";
export const SETTINGS_NOTIFICATIONS = "/settings/notifications";
export const SETTINGS_PAYMENT = "/settings/payment";
export const SETTINGS_PRIVACY_AND_SAFETY = "/settings/privacy-and-safety";
export const SETTINGS_SECURITY = "/settings/security";
export const SORARE50 = "/sorare50";
export const SPECIAL_CREDITS = "/special-credits";
export const TERMS_AND_CONDITIONS = "/terms-and-conditions";
export const UNSUBSCRIBE_EMAIL = "/unsubscribe-email";
export const VERIFY_IDENTITY_ID = "/verify-identity/:id";
export const WALLET = "/wallet";
export const ANY_SPORT_SCORES_MATCHES_DAY_GAMEID = "/scores/matches/:day/:gameId";
export const ANY_SPORT_TEAMS_SLUG = "/teams/:slug";
export const ANY_SPORT_PLAY_EVENTTYPE_FIXTURE_GAME_CENTER = "/play/:eventType/:fixture/game-center";
export const ANY_SPORT_PLAY_EVENTTYPE_COMPOSE_LEADERBOARD_LINEUP_LINEUP = "/play/:eventType/compose/:leaderboard/lineup/:lineup";
export const ANY_SPORT_PLAY_EVENTTYPE_COMPOSE_LEADERBOARD_MANAGERTEAM_MANAGERTEAM = "/play/:eventType/compose/:leaderboard/managerTeam/:managerTeam";
export const ANY_SPORT_PLAY_EVENTTYPE_COMPOSE_LEADERBOARD = "/play/:eventType/compose/:leaderboard";
export const ANY_SPORT_PLAY_EVENTTYPE_LINEUPS_ID = "/play/:eventType/lineups/:id";
export const ANY_SPORT_SCORES_MATCHES_DAY_GAMEID_BOX_SCORE = "/scores/matches/:day/:gameId/box-score";
export const ANY_SPORT_SCORES_MATCHES_DAY_GAMEID_PLAYERS = "/scores/matches/:day/:gameId/players";
export const ANY_SPORT_SCOUTING_CENTER_GAME_GAMEID = "/scouting-center/game/:gameId";
export const ANY_SPORT_TEAMS_SLUG_CARDS = "/teams/:slug/cards";
export const ANY_SPORT_TEAMS_SLUG_PLAYERS = "/teams/:slug/players";
export const ANY_SPORT_MARKET_MOBILE_INSTANT_BUY = "/market/mobile-instant-buy";
export const ANY_SPORT_ONBOARDING_COMPOSE_SLUG = "/onboarding/compose/:slug";
export const ANY_SPORT_ONBOARDING_QUICK_PLAY_TUTORIAL = "/onboarding/quick-play-tutorial";
export const ANY_SPORT_SCORES_MATCHES_DAY_GAMEID_STATS = "/scores/matches/:day/:gameId/stats";
